import React from 'react';
import { Eye, Building2, Handshake } from 'lucide-react';
import VisitBookingPage from '../components/VisitBookingPage';

// Swap these for the real client experience videos (YouTube/Vimeo embed URLs).
const CQC_VIDEO_1 = '';
const CQC_VIDEO_2 = '';

const BookCQC = () => (
  <VisitBookingPage
    type="cqc"
    accent="red"
    title="CQC Visit"
    subtitle="2-Day Immersion at the CQC Home Office"
    location="5102 Durham-Chapel Hill Blvd #100, Durham, NC 27707"
    overviewTitle="What to Expect"
    overviewCards={[
      {
        icon: Eye,
        title: 'Behind the Scenes',
        text: 'Experience how CQC operates day-to-day and learn from our proven processes.',
      },
      {
        icon: Building2,
        title: 'Leadership Access',
        text: 'Meet with our leadership team and learn from their strategic insights.',
      },
      {
        icon: Handshake,
        title: 'Meeting Involvement',
        text: "You'll sit in on Design, Sales, and key business meetings.",
      },
    ]}
    videos={[
      { url: CQC_VIDEO_1, caption: 'A client on their CQC immersion' },
      { url: CQC_VIDEO_2, caption: 'Inside the 2-day experience' },
    ]}
  />
);

export default BookCQC;
